import React from "react";
import getConfig from "next/config";
import Link from "next/link";

import PhoneCall from "@components/Icons/PhoneCall";
import Map from "@components/Icons/Map";
import FileText from "@components/Icons/FileText";

const Col = ({ icon, title, children, classesProp = "", isLast = false }) => (
  <div
    className={`
    flex md:w-1/3 md:ml-4 relative
    lg:mt-4 pt-10 md:pt-12 px-6
    ${isLast ? "" : "pb-16 md:pb-0"}
    ${classesProp}
  `}
  >
    <div className="w-full text-center text-sm leading-24px -tracking-0.29">
      <div className="flex justify-center text-white">{icon}</div>

      <h2 className="text-26px leading-33.8 -tracking-0.54 mt-6">{title}</h2>

      {children}
    </div>
  </div>
);

const ColItem = ({ item }) => (
  <li className="mt-1">
    {item.slug ? (
      <Link href={`${settings.baseUrl}${item.slug}`} passHref>
        <a className="text-black hover:text-secondary">{item.name}</a>
      </Link>
    ) : (
      <a
        className="text-black hover:text-secondary"
        href={item.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        {item.name}
      </a>
    )}
  </li>
);

const {
  publicRuntimeConfig: { settings, content },
} = getConfig();

const SupportFooter = () => {
  const { info, contact } = content.supportMenuLinks;

  return (
    <section className="pt-6 md:flex md:-ml-4">
      <Col
        title={contact.name}
        icon={<PhoneCall width="150px" height="150px" />}
        classesProp="custom-border md-custom-border-right custom-border-bottom"
      >
        <ul className="m-0 mt-4 p-0">
          {contact.links.map((item) => (
            <ColItem key={item.slug} item={item} />
          ))}
        </ul>
      </Col>

      <Col
        title={`Reteaua de magazine`}
        icon={<Map width="150px" height="150px" />}
        classesProp="custom-border md-custom-border-right custom-border-bottom"
      >
        <p className="mb-4 mt-4">{`Vezi adresele magazinelor, datele de contact si orarul de functionare.`}</p>
        <Link href={`${settings.baseUrl}/magazine/`} passHref>
          <a
            title={`Lista magazinelor ${content.websiteTitle}`}
            className="text-red-brand hover:text-bleu-hover underline"
          >
            {`Lista magazinelor ${content.websiteTitle}`}
          </a>
        </Link>
      </Col>

      <Col
        title={info.name}
        isLast={true}
        icon={<FileText width="150px" height="150px" />}
      >
        <ul className="m-0 mt-4 p-0">
          {info.links.map((item) => (
            <ColItem key={item.slug || item.link} item={item} />
          ))}
        </ul>
      </Col>

      <style suppressHydrationWarning>
        {`
          .custom-border:after {
            content: '';
            display: inline-block;
            position: absolute;
            background-color: #D8D8D8;
          }

          .custom-border-bottom:after {
            bottom: 0;
            right: 20%;
            left: 20%;
            width: auto;
            height: 1px;
          }

          @media (min-width: 768px) {
            .custom-border-bottom:after {
              display: none;
            }
          }
        `}
      </style>
    </section>
  );
};

export default SupportFooter;
